import checkIsMobile from 'is-mobile';

export const isMobileOrTablet = () =>
  checkIsMobile({ featureDetect: true, tablet: true });

export const isMobile = () =>
  checkIsMobile({ featureDetect: true, tablet: false });
